const noop = any => any;
export { noop };